<template>
<div class="contact">
  <div class="contact-row">理赔服务：4000999559-1</div>
  <div class="contact-row">其他服务：4000999559-2</div>
  <div class="contact-row">投诉建议：4000999559-3</div>
  <div class="contact-line"></div>
  <div class="contact-time">
    工作时间：周一 ~ 周日 10:00-20:00
  </div>
</div>
</template>

<script>
export default {}
</script>

<style scoped lang="scss">
.contact {
  width:898px;
  height:714px;
  padding: 50px;
  background:rgba(255,255,255,1);
  box-shadow:0px 16px 24px -4px rgba(137,154,230,0.08);
  border:1px solid rgba(236,238,243,0.96);
  .contact-row {
    font-size:16px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(140,142,162,1);
    line-height:26px;
    letter-spacing:1px;
  }
  .contact-line {
    width:208px;
    height:1px;
    background-color: #8C8EA2;
    margin-top: 20px;
    opacity: 0.5;
  }
  .contact-time {
    font-size:16px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(140,142,162,1);
    line-height:26px;
    letter-spacing:1px;
    margin-top: 20px;
  }
}
</style>
